// OpenPositions.js
import { positions } from './OpeningData'; // Adjust the path as needed

function OpenPositions() {
    return (
        <div className="container open-positions-container">
            <h1 className="open-positions-title text-center mt-5">Open Positions</h1>
            <div className="row g-4 p-0 justify-content-start">
                {/* Map through the positions array to render each position */}
                {positions.map((position, index) => (
                    <div key={index} className="col-lg-4 col-md-6 col-sm-12 d-flex">
                        <div className="position-card w-100">
                            <div className="card-badge">{position.type || "Full Time"}</div>
                            <h2 className="card-title">{position.title}</h2>
                            <div className="card-details">
                                <div className="detail-item">
                                    <svg className="detail-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" />
                                        <circle cx="12" cy="10" r="3" />
                                    </svg>
                                    <span>{position.location}</span>
                                </div>
                                <div className="detail-item">
                                    <svg className="detail-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 8v4l3 3M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
                                    </svg>
                                    <span>{position.experience}</span>
                                </div>
                            </div>
                            <div className="card-footer">
                                <a href={position.apply_url}><button className="apply-button">Apply Now</button>
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default OpenPositions;